import history from '../../../history';

export const addDescription = (values, createCallAsync, setVisible, authId, selectedPatient) => {
    const { description } = values;
    createCallAsync({ description, creator: authId, patient: selectedPatient._id });
    setVisible(false);
    history.push('/patients');
};
